import React, { useRef, useEffect, useState, useContext, useMemo, useLayoutEffect } from 'react';
import styles from './GanttChartAll.module.css';
import Procesory from './procesory_btn/Procesory';
import { AppContext } from 'context/AppContext';
import { druk_alert } from 'actions/druk_alert';
import { useGant } from './useGant';
import { ChevronsLeft, ChevronsRight, LucideGitBranchPlus, Magnet, Move, Move3D, RefreshCcw, Scaling, Shrink, Waypoints, X, XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getNameOfElementTyp } from 'actions/getNameOfElementTyp';
import GanttContextMenu from './GanttContextMenu';
import ModalGrupyTechnologii from './ModalGrupyTech/ModalGrupyTechnologii';
import { TechnologyContext } from 'context/TechnologyContext';
import { updateZmienCzasTrwaniaGrupyGant } from 'actions/updateZmienCzasTrwaniaGrupyGant';
import { updateZmienCzasTrwaniaGrupyGantPrzerwa } from 'actions/updateZmienCzasTrwaniaGrupyGantPrzerwa';
import { updateZmienCzasTrwaniaGrupyOprawaGant } from 'actions/updateZmienCzasTrwaniaGrupyOprawaGant';
import { updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa } from 'actions/updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa';
import { dateISOtoPL } from 'actions/dateISOtoPL';
import { date_time } from 'actions/date_time';
import { date_bez_time } from 'actions/date_bez_time';
import { useDragDropGant } from './DragDrop/useDragDropGant';
import { useAccess } from 'hooks/useAccess';
import GanttConnections from './GanttConnections';
import GanttOprawaConnections from './GanttOprawaConnections';
import GanttSearch from './GanttSearch';

const GanttChartAll = ({ stages }) => {
  const chartRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  const { setGrupaWykonan } = useContext(TechnologyContext);
  

  const [minDate, setMinDate] = useState(null);
  const [etykieta, setEtykieta] = useState("");
  const [maxDate, setMaxDate] = useState(null);
  const [totalChartWidth, setTotalChartWidth] = useState(0);
  const [scaleFactor, setScaleFactor] = useState(0.25);

  const contextApp = useContext(AppContext);
  const procesory = contextApp.procesory;
  
  const [nowTime, setNowTime] = useState(new Date()); 
  const [colorFrom, setColorFrom] = useState(4);

  const [selectedGrup, setSelectedGrup] = useState(null);
  const [selectedZamowienieId, setSelectedZamowienieId] = useState(null);
  const [selectedShipmentDate, setSelectedShipmentDate] = useState(null);
  const [rowYPositions, setRowYPositions] = useState({});
  const {refreshGant, refreshGantAll, refreshGantZakonczone} = useGant();
  const [contextMenu, setContextMenu] = useState(null);

  const [showHourLines, setShowHourLines] = useState(true);
  const [modalGrupyOpen, setModalGrupyOpen] = useState(false);
  const [resizable, setResizable] = useState(true);
  const [moveable, setMoveable] = useState(true);

  // Stany dla obsługi przeciągania (resize) i snapowania
  const [isResizing, setIsResizing] = useState(false);
  const [resizingStage, setResizingStage] = useState(null);
  const [resizeStartX, setResizeStartX] = useState(0);
  const [currentWidthPx, setCurrentWidthPx] = useState(0);
  const [resizingEndDate, setResizingEndDate] = useState(null);
  const [resizingLeftPx, setResizingLeftPx] = useState(0);
  const [isSnapping, setIsSnapping] = useState(false);

  const navigate = useNavigate();

  const hasScrolledRef = useRef(false);

  const { handleDrop, handleDragOver, handleDragStart } = useDragDropGant(false);
  const {wolno,canDragOnGant} = useAccess(false);

  const [showAllConections, setShowAllConections] = useState(false);
  const [showElementConections, setShowElementConections] = useState(true);
  const [showOprawaConnections, setShowOprawaConnections] = useState(true);

  const [searchResults, setSearchResults] = useState([]); // lista znalezionych global_id lub zamowienie_id
const [isSearchActive, setIsSearchActive] = useState(false);
const [searchMode, setSearchMode] = useState('current'); // 'current' | 'archive'


  useEffect(() => {
  // Przewijamy tylko wtedy, gdy wykres ma już obliczoną szerokość i jeszcze nie przewijaliśmy
  if (totalChartWidth > 0 && !hasScrolledRef.current) {
    const timer = setTimeout(() => {
      handleScrollToNow();
      hasScrolledRef.current = true; // Oznaczamy, że pierwsze przewinięcie się odbyło
    }, 100);

    return () => clearTimeout(timer);
  }
}, [totalChartWidth]);

  // Grupowanie etapów według procesora
  const groupedStages = useMemo(() => {
    return stages?.reduce((acc, stage) => {
      const { procesor_id } = stage;

      if (procesor_id === 51 || procesor_id === 52) {
        return acc;
      }

      if (!acc[procesor_id]) {
        acc[procesor_id] = [];
      }
      acc[procesor_id].push(stage);
      return acc;
    }, {});
  }, [stages]);

  const processorIds = useMemo(() => Object.keys(groupedStages || {}), [groupedStages]);
  const allStagesList = useMemo(() => Object.values(groupedStages || {}).flat(), [groupedStages]);

  useEffect(() => {
    if (allStagesList && allStagesList.length > 0) {
      const allDates = allStagesList.flatMap(stage => [new Date(stage.start), new Date(stage.end)]);

      if (allDates.length === 0) return;

      const calculatedMinDate = new Date(Math.min(...allDates));
      const calculatedMaxDate = new Date(Math.max(...allDates));

      calculatedMinDate.setHours(calculatedMinDate.getHours() - 1, 0, 0, 0);
      calculatedMaxDate.setHours(calculatedMaxDate.getHours() + 2, 0, 0, 0);

      setMinDate(calculatedMinDate);
      setMaxDate(calculatedMaxDate);

      const totalTimeSpanMinutes = (calculatedMaxDate.getTime() - calculatedMinDate.getTime()) / (1000 * 60);
      setTotalChartWidth(totalTimeSpanMinutes * scaleFactor);
    }
  }, [allStagesList, scaleFactor]);

  useLayoutEffect(() => {
    if (!chartRef.current) return;
    
    const rows = chartRef.current.querySelectorAll(`.${styles.processorRow}`);
    const positions = {};

    processorIds.forEach((processorId, index) => {
      if (rows[index]) {
        positions[processorId] = rows[index].offsetTop + (rows[index].offsetHeight / 2);
      }
    });

    setRowYPositions(positions);
  }, [processorIds, totalChartWidth, scaleFactor, stages]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     handleScrollToNow();
  //   }, 100);

  //   return () => clearTimeout(timer);
  // }, []);

  const calculateBarProperties = (start, end) => {
    if (!minDate || !maxDate || !totalChartWidth) {
      return { width: '0px', marginLeft: '0px', leftPx: 0, widthPx: 0 };
    }

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const stageDurationMs = new Date(end).getTime() - new Date(start).getTime();
    const startOffsetMs = new Date(start).getTime() - minDate.getTime();

    const widthPx = Math.max(0, (stageDurationMs / totalTimeSpanMs) * totalChartWidth);
    const marginLeftPx = Math.max(0, (startOffsetMs / totalTimeSpanMs) * totalChartWidth);

    return {
      width: `${widthPx}px`,
      marginLeft: `${marginLeftPx}px`,
      leftPx: marginLeftPx,
      widthPx: widthPx
    };
  };

  // Funkcja pomocnicza do snapowania do pełnej godziny
  const snapDateToNearestHour = (dateObj) => {
    const minutes = dateObj.getMinutes();
    const hours = dateObj.getHours();
    
    if (minutes >= 30) {
      dateObj.setHours(hours + 1, 0, 0, 0);
    } else {
      dateObj.setHours(hours, 0, 0, 0);
    }
    return dateObj;
  };

  const formatDateToCustomString = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  // Globalna obsługa zdarzeń przeciągania krawędzi (resize) z progiem ruchów (Threshold)
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!resizingStage) return;
      
      const deltaX = e.clientX - resizeStartX;

      // Aktywacja trybu resize dopiero po przesunięciu o więcej niż 5px
      if (!isResizing && Math.abs(deltaX) > 5) {
        setIsResizing(true);
      }

      // Dopóki kursor nie przekroczy progu, anulujemy dalsze obliczenia
      if (!isResizing && Math.abs(deltaX) <= 5) return;

      const { widthPx: initialWidthPx, leftPx: initialLeftPx } = calculateBarProperties(resizingStage.start, resizingStage.end);
      
      const newWidth = Math.max(20, initialWidthPx + deltaX);
      setCurrentWidthPx(newWidth);
      setResizingLeftPx(initialLeftPx + newWidth);

      const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
      const durationMs = (newWidth / totalChartWidth) * totalTimeSpanMs;
      const startTimeMs = new Date(resizingStage.start).getTime();
      let currentEndTimeMs = startTimeMs + durationMs;
      
      let currentDateObj = new Date(currentEndTimeMs);
      if (isSnapping) {
        currentDateObj = snapDateToNearestHour(currentDateObj);
      }

      setResizingEndDate(currentDateObj);
    };

    const handleMouseUp = (e) => {
      if (!resizingStage) return;

      // Jeśli użytkownik tylko kliknął (brak aktywacji isResizing), resetujemy stany i wychodzimy
      if (!isResizing) {
        setResizingStage(null);
        setResizingEndDate(null);
        return;
      }

      const deltaX = e.clientX - resizeStartX;
      const { widthPx: initialWidthPx } = calculateBarProperties(resizingStage.start, resizingStage.end);
      const finalWidthPx = Math.max(20, initialWidthPx + deltaX);

      const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
      const durationMs = (finalWidthPx / totalChartWidth) * totalTimeSpanMs;
      
      const startTimeMs = new Date(resizingStage.start).getTime();
      let newEndTimeMs = startTimeMs + durationMs;
      
      let newEndDateObj = new Date(newEndTimeMs);
      if (isSnapping) {
        newEndDateObj = snapDateToNearestHour(newEndDateObj);
      }

      const newEndDate = formatDateToCustomString(newEndDateObj);

      if (resizingStage.proces_nazwa_id == 6) {
        // oprawa
        if (resizingStage.typ_grupy === 1) {
          updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        } else if (resizingStage.typ_grupy === 2) {
          updateZmienCzasTrwaniaGrupyOprawaGant(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        }
      } else {
        // reszta procesów
        if (resizingStage.typ_grupy === 1) {
          updateZmienCzasTrwaniaGrupyGantPrzerwa(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        } else if (resizingStage.typ_grupy === 2) {
          updateZmienCzasTrwaniaGrupyGant(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        }
      }

      setIsResizing(false);
      setResizingStage(null);
      setResizingEndDate(null);
    };

    if (resizingStage) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [resizingStage, isResizing, resizeStartX, minDate, maxDate, totalChartWidth, isSnapping]);

  const getColor = (stage, technologiaId, zamowienieId) => {
    let parametr;

    if (colorFrom === 1) { 
      parametr = stage.klient_id;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 2) { 
      const hashString = `${technologiaId}-${zamowienieId}`;
      let hash = 0;
      for (let i = 0; i < hashString.length; i++) {
        hash = hashString.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = (technologiaId * 137.508) % 360;
      const saturation = 70 + (hash % 30);
      const lightness = 50 + (hash % 10);
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    if (colorFrom === 3) { 
      parametr = stage.data_spedycji;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 4) { 
      if (stage.typ_grupy == 1) return `linear-gradient(to bottom, #cfcfcf67 5%, #eeeeee52 50%, #cfcfcf67 90%)`;
      if (stage.status == 1) return `linear-gradient(to bottom, #aaaaaa7c 5%, #c9c9c97c 50%, #aaaaaa7c 90%)`;
      if (stage.status == 2) return `linear-gradient(to bottom, #a9ce54 5%, #c1e078 50%, #a9ce54 90%)`;
      if (stage.status == 3) return `linear-gradient(to bottom, #e3c956 5%, #f8df70 50%, #e3c956 90%)`;
      if (stage.status == 4) return `linear-gradient(to bottom, #838383 5%, #9c9c9c 50%, #838383 90%)`;
    }
  };

  const getOutlineSelected = (stage) => {
    if (stage.typ_grupy == 1) return `1px solid #cfcfcf`;
    if (stage.typ_grupy == 2) return `2px solid #4d9aff`;
  };

  const getOutline = (stage) => {
    if (stage.typ_grupy == 1) return `1px solid #cfcfcf`;
    if (stage.typ_grupy == 2) return `none`;
  };

  const renderWeekendBackgrounds = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const weekendBlocks = [];
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();

    let currentDate = new Date(minDate);
    currentDate.setHours(0, 0, 0, 0);

    while (currentDate <= maxDate) {
      const dayOfWeek = currentDate.getDay();

      if (dayOfWeek === 6 || dayOfWeek === 0) {
        const dayStart = new Date(currentDate);
        const dayEnd = new Date(currentDate);
        dayEnd.setHours(23, 59, 59, 999);

        const actualStart = dayStart < minDate ? minDate : dayStart;
        const actualEnd = dayEnd > maxDate ? maxDate : dayEnd;

        const startOffsetMs = actualStart.getTime() - minDate.getTime();
        const durationMs = actualEnd.getTime() - actualStart.getTime();

        const leftPx = (startOffsetMs / totalTimeSpanMs) * totalChartWidth;
        const widthPx = (durationMs / totalTimeSpanMs) * totalChartWidth;

        weekendBlocks.push(
          <div
            key={`weekend-${currentDate.getTime()}`}
            className={styles.weekendOverlay}
            style={{ left: `${leftPx}px`, width: `${widthPx}px` }}
          />
        );
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return weekendBlocks;
  };

  const renderHourLines = () => {
    if (!showHourLines || !minDate || !maxDate || totalChartWidth === 0) return null;

    const lines = [];
    const interval = 24 * 60 * 60 * 1000;
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= maxDate) {
      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

      hoursToAdd.forEach((hour, hourIndex) => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          lines.push(
            <div 
              key={`grid-line-${dayIndex}-${hourIndex}-${hourDate.getTime()}`}
              className={styles.hourLineGrid}
              style={{ left: `${hourLeftPosition}px` }}
            />
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
      dayIndex++;
    }
    return lines;
  };

  const renderTimelineMarkers = (prefix = 'marker') => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const markers = [];
    const daysOfWeek = ['N', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'];
    const interval = 24 * 60 * 60 * 1000;
    
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= maxDate) {
      const offsetMs = currentDate.getTime() - minDate.getTime();
      const leftPosition = (offsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

      markers.push(
        <div 
          key={`${prefix}-day-${dayIndex}-${currentDate.getTime()}`} 
          className={styles.timelineMarker} 
          style={{ left: `${leftPosition}px`, transform: 'translateX(-50%)' }}
        >
          {daysOfWeek[currentDate.getDay()]} {String(currentDate.getDate()).padStart(2, '0')}/{String(currentDate.getMonth() + 1).padStart(2, '0')}
        </div>
      );

      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

      hoursToAdd.forEach((hour, hourIndex) => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          markers.push(
            <div 
              key={`${prefix}-hour-${dayIndex}-${hourIndex}-${hourDate.getTime()}`} 
              className={styles.timelineSubMarker} 
              style={{ left: `${hourLeftPosition}px`, transform: 'translateX(-50%)' }}
            >
              {hour}:00
            </div>
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
      dayIndex++;
    }
    return markers;
  };

  const calculateNowPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return 0;
    const now = nowTime.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now - minDate.getTime();
    const leftPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };

  const calculateShipmentPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0 || !selectedShipmentDate) return 0;
    const shipmentDateObj = new Date(selectedShipmentDate);
    shipmentDateObj.setHours(6, 0, 0, 0);

    const shipmentTime = shipmentDateObj.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const shipmentOffsetMs = shipmentTime - minDate.getTime();
    const leftPosition = (shipmentOffsetMs / totalTimeSpanMs) * totalChartWidth;

    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };

  const handleScrollToNow = () => {
    if (!scrollWrapperRef.current || !minDate || !maxDate || totalChartWidth === 0) return;
    const now = new Date();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now.getTime() - minDate.getTime();
    const scrollPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    scrollWrapperRef.current.scrollLeft = scrollPosition - (scrollWrapperRef.current.clientWidth / 2);
  };

  const handleScaleChange = (event) => {
    setScaleFactor(event);
  };

  // const connectionLines = useMemo(() => {
  //   if (!selectedZamowienieId || !showAllConections || !minDate || !maxDate || !totalChartWidth) return [];

  // //   if (!showAllConections && !selectedZamowienieId) return [];
  // // if (!minDate || !maxDate || !totalChartWidth) return [];

  //   const matchedStages = [];

  //   processorIds.forEach((processorId) => {
  //     const rowStages = groupedStages[processorId] || [];
  //     const y = rowYPositions[processorId] || 0;

  //     rowStages.forEach(stage => {
  //       if (stage.zamowienie_id === selectedZamowienieId) {
  //         const { leftPx, widthPx } = calculateBarProperties(stage.start, stage.end);

  //         matchedStages.push({
  //           startMs: new Date(stage.start).getTime(),
  //           outPoint: { x: leftPx + widthPx, y },
  //           inPoint: { x: leftPx, y }
  //         });
  //       }
  //     });
  //   });

  //   matchedStages.sort((a, b) => a.startMs - b.startMs);

  //   const lines = [];
  //   for (let i = 0; i < matchedStages.length - 1; i++) {
  //     lines.push({
  //       from: matchedStages[i].outPoint,
  //       to: matchedStages[i + 1].inPoint
  //     });
  //   }

  //   return lines;
  // }, [selectedZamowienieId, groupedStages, processorIds, rowYPositions, minDate, maxDate, totalChartWidth]);

  const handleCenterOnStage = (stage, targetScale = 0.5) => {
    if (!minDate || !maxDate || !totalChartWidth || !scrollWrapperRef.current) return;

    setScaleFactor(targetScale);

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const startOffsetMs = new Date(stage.start).getTime() - minDate.getTime();
    
    const estimatedTotalWidth = ((maxDate.getTime() - minDate.getTime()) / (1000 * 60)) * targetScale;
    const stageLeftPx = (startOffsetMs / totalTimeSpanMs) * estimatedTotalWidth;
    const stageDurationMs = new Date(stage.end).getTime() - new Date(stage.start).getTime();
    const stageWidthPx = (stageDurationMs / totalTimeSpanMs) * estimatedTotalWidth;

    const stageCenterPx = stageLeftPx + (stageWidthPx / 2);

    setTimeout(() => {
      if (scrollWrapperRef.current) {
        const containerWidth = scrollWrapperRef.current.clientWidth;
        scrollWrapperRef.current.scrollLeft = stageCenterPx - (containerWidth / 2);
      }
    }, 50);
  };

  const handleCenterOnNow = (targetScale = 0.5) => {
    if (!minDate || !maxDate || !totalChartWidth || !scrollWrapperRef.current) return;

    setScaleFactor(targetScale);

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const now = new Date();
    const nowOffsetMs = now.getTime() - minDate.getTime();
    
    const estimatedTotalWidth = ((maxDate.getTime() - minDate.getTime()) / (1000 * 60)) * targetScale;
    const nowPositionPx = (nowOffsetMs / totalTimeSpanMs) * estimatedTotalWidth;

    setTimeout(() => {
      if (scrollWrapperRef.current) {
        const containerWidth = scrollWrapperRef.current.clientWidth;
        scrollWrapperRef.current.scrollLeft = nowPositionPx - (containerWidth / 2);
      }
    }, 50);
  };



const handleFitConnectedStagesToScreen = () => {
  if (!selectedZamowienieId || !scrollWrapperRef.current || !minDate || !maxDate) return;

  // 1. Znajdujemy wszystkie etapy powiązane z wybranym zamówieniem
  const connectedStages = stages.filter(stage => stage.zamowienie_id === selectedZamowienieId);

  if (connectedStages.length === 0) return;

  // 2. Pobieramy czasy rozpoczęcia i zakończenia etapów
  const startTimes = connectedStages.map(s => new Date(s.start).getTime());
  const endTimes = connectedStages.map(s => new Date(s.end).getTime());

  const earliestStartMs = Math.min(...startTimes);
  let latestEndMs = Math.max(...endTimes);

  // 3. Uwzględniamy data_spedycji + 6 godzin, jeśli istnieje w zamówieniu
  // Pobieramy data_spedycji z pierwszego znalezionego etapu zamówienia (lub ze stanu selectedShipmentDate)
  const shipmentDateRaw = selectedShipmentDate || connectedStages.find(s => s.data_spedycji)?.data_spedycji;

  if (shipmentDateRaw) {
    const shipmentDateObj = new Date(shipmentDateRaw);
    // Ustawiamy godzinę 06:00 (tak jak w Twojej funkcji calculateShipmentPosition)
    shipmentDateObj.setHours(6, 0, 0, 0);

    // Dodajemy 6 godzin do terminu spedycji
    const shipmentPlus6hMs = shipmentDateObj.getTime() + (6 * 60 * 60 * 1000);

    // Jeśli spedycja + 6h wypada później niż koniec ostatniego etapu, rozszerzamy zakreślany obszar
    if (shipmentPlus6hMs > latestEndMs) {
      latestEndMs = shipmentPlus6hMs;
    }
  }

  // 4. Obliczamy czas trwania tego zakresu w minutach
  const durationMinutes = (latestEndMs - earliestStartMs) / (1000 * 60);
  if (durationMinutes <= 0) return;

  // Szerokość widocznego kontenera (z małym marginesem 60px)
  const containerWidth = Math.max(200, scrollWrapperRef.current.clientWidth - 60);

  // 5. Wyliczamy optymalny scaleFactor
  let calculatedScale = containerWidth / durationMinutes;
  calculatedScale = Math.min(Math.max(calculatedScale, 0.01), 5.0);

  // 6. Ustawiamy nowy zoom
  setScaleFactor(calculatedScale);

  // 7. Wyśrodkowujemy widok na wyliczonym zakresie (od pierwszego etapu do końca ostatniego/spedycji)
  const totalChartDurationMs = maxDate.getTime() - minDate.getTime();
  const startOffsetMs = earliestStartMs - minDate.getTime();
  const rangeDurationMs = latestEndMs - earliestStartMs;

  const estimatedTotalWidth = (totalChartDurationMs / (1000 * 60)) * calculatedScale;
  const rangeLeftPx = (startOffsetMs / totalChartDurationMs) * estimatedTotalWidth;
  const rangeWidthPx = (rangeDurationMs / totalChartDurationMs) * estimatedTotalWidth;

  const rangeCenterPx = rangeLeftPx + (rangeWidthPx / 2);

  setTimeout(() => {
    if (scrollWrapperRef.current) {
      const currentContainerWidth = scrollWrapperRef.current.clientWidth;
      scrollWrapperRef.current.scrollLeft = rangeCenterPx - (currentContainerWidth / 2);
    }
  }, 50);
};

const handleScrollToStart = () => {
  if (scrollWrapperRef.current) {
    scrollWrapperRef.current.scrollTo({
      left: 0,
      // behavior: 'smooth'
    });
  }
};

const handleScrollToEnd = () => {
  if (scrollWrapperRef.current) {
    scrollWrapperRef.current.scrollTo({
      left: scrollWrapperRef.current.scrollWidth,
      // behavior: 'smooth'
    });
  }
};

// wyszukiwarka


// ... wewnątrz komponentu GanttChartAll ...

// Stany wyszukiwania

// Logic wywoływana przy kliknięciu "Szukaj"
const handleSearch = ({ nr, rok, mode }) => {
  setSearchMode(mode);

  if (mode === 'archive') {
    // TOD0: Miejsce na Twoje zapytanie API do archiwum
    console.log(`[API Archiwum] Pobieranie zamówienia Nr: ${nr}, Rok: ${rok}`);
    alert(`Później...`);
    return;
  }

  // Dla trybu 'current' – szukamy w obecnej tablicy stages
  const matched = stages.filter((stage) => {
    const matchNr = String(stage.nr || '').trim() === String(nr).trim();
    const matchRok = rok ? String(stage.rok || '').trim() === String(rok).trim() : true;
    return matchNr && matchRok;
  });

  const matchedIds = matched.map(s => s.global_id);
  setSearchResults(matchedIds);
  setIsSearchActive(true);

  // Opcjonalnie: Jeśli coś znaleziono, wyśrodkuj wykres na pierwszym pasującym etapie
  if (matched.length > 0) {
    handleCenterOnStage(matched[0]);
    // Jeśli zrealizujesz automatyczny wybór zamówienia:
    setSelectedZamowienieId(matched[0].zamowienie_id);
    setSelectedShipmentDate(matched[0].data_spedycji);
  }
};

const handleClearSearch = () => {
  setSearchResults([]);
  setIsSearchActive(false);
};


  return (
    <div className={styles.chartContainer}>
      <div className={styles.header}
      onDoubleClick={()=>{console.log(contextApp.decodedToken)}}
      >
        <div className={styles.btnFormContainer}>
<div className={styles.btnFormContainer}>
    {/* <button 
      className={styles.scrollToNowBtn}
      onClick={() => refreshGantAll()}
      style={{ background: 'linear-gradient(to bottom, #a9ce54 5%, #b4da5d 50%, #a9ce54 90%)' }}
      title="Odśwież"
    >
      <RefreshCcw size={20} style={{ marginRight: '0px' }} />
    </button> */}
  </div>

  {/* WSTAWIONA WYSZUKIWARKA */}
  <GanttSearch 
    onSearch={handleSearch} 
    onClear={handleClearSearch}
    onModeChange={(mode) => setSearchMode(mode)}
  />

  <div className={styles.controls}>
    {/* ... pozostałe przyciski Zoom, Teraz, Snapping itp. ... */}
  </div>
        </div>
        
        <div className={styles.controls}>
          
          <button
  className={styles.scrollToNowBtn}
  onClick={handleFitConnectedStagesToScreen}
  disabled={!selectedZamowienieId}
  style={{
    backgroundColor: selectedZamowienieId ? '#2a9d8f' : '#63636396',
    cursor: selectedZamowienieId ? 'pointer' : 'not-allowed'
  }}
  title="Dopasuj do ekranu"
>

              <Shrink size={20} style={{marginRight:"0px"}}/>

</button>
          <div className={styles.controls}>
                      <button 
              className={styles.scrollToNowBtn}
              onClick={() => setShowElementConections(prev => !prev)}
              style={{ backgroundColor: showElementConections ? '#2a9d8f' : '#63636396' }}
              title="Przenoszenie klocka"
            >
              <Waypoints size={20} style={{marginRight:"0px"}}/>
            </button>
            <button 
              className={styles.scrollToNowBtn}
              onClick={() => setMoveable(prev => !prev)}
              style={{ backgroundColor: moveable ? '#8abe11' : '#63636396' }}
              title="Przenoszenie klocka"
            >
              <Move size={20} style={{marginRight:"0px"}}/>
            </button>

            <button 
              className={styles.scrollToNowBtn}
              onClick={() => setResizable(prev => !prev)}
              style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}
              title="Rozciąganie klocka"
            >
              <Scaling size={20} style={{marginRight:"0px"}}/>
            </button>

            <button 
              className={styles.scrollToNowBtn}
              onClick={() => setIsSnapping(prev => !prev)}
              style={{ backgroundColor: isSnapping ? '#8abe11' : '#63636396' }}
              title="Przyciąganie klocka do pełnej godziny"
            >
              <Magnet size={20} style={{marginRight:"0px"}}/>
            </button>

            {/* <button className={styles.scrollToNowBtn} onClick={handleScrollToNow}>
              Terazd
            </button> */}
            <button 
    className={styles.scrollToNowBtn} 
    onClick={handleScrollToStart}
    title="Przejdź do początku wykresu"
  >
    <ChevronsLeft size={18} style={{ marginRight: '4px' }} />
   
  </button>

  {/* Przycisk przewijania do stanu 'Teraz' */}
  <button className={styles.scrollToNowBtn} onClick={handleScrollToNow}>
    Teraz
  </button>

  {/* Przycisk przewijania do końca */}
  <button 
    className={styles.scrollToNowBtn} 
    onClick={handleScrollToEnd}
    title="Przejdź do końca wykresu"
  >
   
    <ChevronsRight size={18} style={{ marginLeft: '4px' }} />
  </button>
      <button 
      className={styles.scrollToNowBtn}
      onClick={() => refreshGantAll()}
      style={{ background: 'linear-gradient(to bottom, #a9ce54 5%, #b4da5d 50%, #a9ce54 90%)' }}
      title="Odśwież"
    >
      <RefreshCcw size={20} style={{ marginRight: '0px' }} />
    </button>

            <span>Zoom:</span>
            <div style={{ display: 'inline-flex', gap: '5px', marginLeft: '10px' }}>
              {[0.05, 0.10,0.15,0.25, 0.5, 1.0, 2.0].map((val) => (
                <button
                  key={val}
                  onClick={() => handleCenterOnNow(val)}
                  style={{
                    padding: '4px 8px',
                    backgroundColor: scaleFactor === val ? '#8abe11' : '#f0f0f0',
                    color: scaleFactor === val ? '#fff' : '#000',
                    border: '1px solid #ccc',
                    cursor: 'pointer',
                    borderRadius: '4px'
                  }}
                >
                  {val}x
                </button>
              ))}
            </div>
          </div>
          

          <button 
            title="Zamknij"
            style={{ background: 'transparent', border: 'none', marginRight: '10px' }}
            onClick={() => { navigate("/Panel"); }}
          >
            <X style={{ marginLeft: '20px', color: '#ffffffd4', height: '30px', width: '30px', padding: '5px', backgroundColor: '#ff0000', borderRadius: '5px' }} size={10} />
          </button>
        </div>
      </div>

      <div className={styles.ganttWrapper}>
        <div className={styles.stageNamesList}>
          <div className={styles.timeline} style={{ visibility: 'hidden', pointerEvents: 'none' }}>
            <div className={styles.timelineMarkersContainer} />
            <div className={styles.timelineLine} />
          </div>
          
          {groupedStages && Object.keys(groupedStages).map(processorId => (
            <div key={`names-group-${processorId}`} className={styles.processorRow}>
              <div className={styles.processorNameFixed}>
                {procesory.find(x => x.id == processorId)?.nazwa}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.scrollWrapper} ref={scrollWrapperRef}>
          <div
            ref={chartRef}
            className={styles.ganttChart}
            style={{ width: `${totalChartWidth}px`, position: 'relative' }}
          >
            {renderWeekendBackgrounds()}
            {renderHourLines()}
            <GanttConnections
          groupedStages={groupedStages}
          processorIds={processorIds}
          rowYPositions={rowYPositions}
          minDate={minDate}
          maxDate={maxDate}
          totalChartWidth={totalChartWidth}
          selectedZamowienieId={selectedZamowienieId}
          showAllConections={showAllConections}
          showElementConections={showElementConections}
          calculateBarProperties={calculateBarProperties}
        />
        <GanttOprawaConnections
  groupedStages={groupedStages}
  processorIds={processorIds}
  rowYPositions={rowYPositions}
  minDate={minDate}
  maxDate={maxDate}
  totalChartWidth={totalChartWidth}
  selectedZamowienieId={selectedZamowienieId}
  showOprawaConnections={showOprawaConnections}
  calculateBarProperties={calculateBarProperties}
/>

            {/* Pionowa linia pomocnicza podczas resize'owania */}
            {isResizing && (
              <div 
                className={styles.resizeGuideLine} 
                style={{ left: `${resizingLeftPx}px` }}
              />
            )}

            {/* <svg
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 10
              }}
            >
              <defs>
                <marker
                  id="arrowhead"
                  markerWidth="6"
                  markerHeight="6"
                  refX="5"
                  refY="3"
                  orient="auto"
                >
                  <polygon points="0 0, 6 3, 0 6" fill="#ff4d4f" />
                </marker>
              </defs>

              {connectionLines.map((line, index) => {
                const { from, to } = line;
                const deltaX = Math.max(20, Math.abs(to.x - from.x) / 2);
                const pathData = `M ${from.x} ${from.y} C ${from.x + deltaX} ${from.y}, ${to.x - deltaX} ${to.y}, ${to.x} ${to.y}`;

                return (
                  <g key={`connection-${index}`}>
                    <path
                      d={pathData}
                      fill="none"
                      stroke="#4d9aff"
                      strokeWidth="2.5"
                      strokeDasharray="5 3"
                      markerEnd="url(#arrowhead)"
                    />
                    <circle cx={from.x} cy={from.y} r="3.5" fill="#ff4d4f" />
                  </g>
                );
              })}
            </svg> */}

            <div className={styles.timeline}>
              <div className={styles.timelineMarkersContainer}>
                {renderTimelineMarkers('top')}
              </div>
              <div className={styles.timelineLine}></div>
            </div>

            <div className={styles.nowLine} style={{ left: `${calculateNowPosition()}px` }}>
              <span className={styles.nowLabel}>TERAZ</span>
            </div>  

            {selectedShipmentDate && (
              <div 
                className={styles.nowLine} 
                style={{ left: `${calculateShipmentPosition()}px`, backgroundColor: '#efd808' }}
              >
                <span className={styles.nowLabelSpedycja} style={{ backgroundColor: '#efd808' }}>SPEDYCJA</span>
              </div>
            )}

            {groupedStages && Object.keys(groupedStages).map(processorId => (
              <div key={`bars-group-${processorId}`} className={styles.processorRow}>
                <div className={styles.processorBarsGroup}>
                  {groupedStages[processorId].map(stage => {
                    const { width, marginLeft, widthPx: baseWidthPx } = calculateBarProperties(stage.start, stage.end);
                    const barColor = getColor(stage, stage.technologia_id, stage.zamowienie_id, colorFrom);
                    const isSelected = selectedZamowienieId === stage.zamowienie_id;
                    const barOutlineSelected = getOutlineSelected(stage);
                    const barOutline = getOutline(stage);
                    const isCurrentlyResizing = isResizing && resizingStage?.global_id === stage.global_id;
                    
                    const finalWidth = isCurrentlyResizing ? `${currentWidthPx}px` : width;

                    return (
                      <div
                        key={`bar-${stage.global_id}`}
                        className={styles.stageBar}
                        onContextMenu={(e) => {
                            if(canDragOnGant(stage.proces_nazwa_id)){

                                                setGrupaWykonan([]);
                          const isSame = selectedZamowienieId === stage.zamowienie_id;
                          setSelectedGrup(stage);
                          // setSelectedZamowienieId(isSame ? null : stage.zamowienie_id);
                          setSelectedZamowienieId( stage.zamowienie_id);
                          setSelectedShipmentDate(isSame ? null : stage.data_spedycji);
                          e.preventDefault();
                          setContextMenu({ x: e.clientX, y: e.clientY, stage: stage });
                            }
        
                        }}
                        style={{
                          width: finalWidth,
                          marginLeft,
                          background: barColor,
                          border: isSelected ? barOutlineSelected : barOutline,
                          outlineOffset: '2px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setGrupaWykonan([]);
                          const isSame = selectedZamowienieId === stage.zamowienie_id;
                          setSelectedZamowienieId(isSame ? null : stage.zamowienie_id);
                          setSelectedShipmentDate(isSame ? null : stage.data_spedycji);
                          setSelectedGrup(stage);
                        }}
                        draggable={canDragOnGant(stage.proces_nazwa_id) && moveable && !isResizing}
                        onDragOver={(event) => { handleDragOver(stage, event); }}
                        onDrop={(event) => { handleDrop(stage, event); }}
                        // onDragStart={(event) => { if (wolno()) { handleDragStart(stage, event); } }}
                        onDragStart={(event) => { handleDragStart(stage, event) }}
                        title={` ${stage.nr || ''} ${stage.rok || ''} ${stage.firma_nazwa || ''} ${stage.tytul || ''} \n 
                        od: ${date_time(stage.start)}  do: ${date_time(stage.end)} 
                        Ilość narządów: ${stage.ilosc_narzadow || '--'}
                        Przeloty: ${stage.przeloty || '--'} szt.
                        Spedycja: ${date_bez_time(stage.data_spedycji) || '--'}
                        Status: ${stage.status}
                        Element: ${getNameOfElementTyp(stage.typ_elementu, contextApp.typ_elementu) || '--'} 
                        Typ grupy: ${stage.typ_grupy}
                        Proces nazwa id: ${stage.proces_nazwa_id}
                        Zamówienie ID : ${stage.zamowienie_id}
                        ARKUSZE ID : ${stage.arkusze_id || 'brak'}
                        ELEMENT ID : ${stage.element_id || 'brak'}
                        TECHNOLOGIA ID : ${stage.technologia_id || 'brak'}
                        
                        `}
                      >
                        <span className={styles.nameText}>
                          {` ${stage.firma_nazwa || `Przerwa`}`}
                        </span>

                        {/* Tooltip z podglądem nowej daty */}
                        {isCurrentlyResizing && resizingEndDate && (
                          <div className={styles.resizeTooltip}>
                            {resizingEndDate.toLocaleString('pl-PL', { 
                              month: '2-digit', 
                              day: '2-digit', 
                              hour: '2-digit', 
                              minute: '2-digit' 
                            })}
                          </div>
                        )}

                        {/* Uchwyt do zmiany rozmiaru (resize) z obsługą zakazu kliknięć bez ruchu */}
                        {resizable && (
                          <div
                            className={styles.resizeHandleRight}

                            onMouseDown={(e) => {

                              if(canDragOnGant(stage.proces_nazwa_id)){
                                  e.stopPropagation();
                              e.preventDefault();
                              
                              // Rejestracja początkowych danych bez natychmiastowego ustawiania isResizing(true)
                              setResizingStage(stage);
                              setResizeStartX(e.clientX);
                              setCurrentWidthPx(baseWidthPx);
                              setResizingEndDate(new Date(stage.end));
                              const { leftPx } = calculateBarProperties(stage.start, stage.end);
                              setResizingLeftPx(leftPx + baseWidthPx);
                              }
                            
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}

            <div className={styles.timeline}>
              <div className={styles.timelineMarkersContainer}>
                {renderTimelineMarkers('bottom')}
              </div>
              <div className={styles.timelineLine}></div>
            </div>
          </div>
        </div>
      </div>

      <GanttContextMenu
        setModalGrupyOpen={setModalGrupyOpen}
        contextMenu={contextMenu}
        onClose={() => setContextMenu(null)}
        onShowDetails={(stage) => {
          alert(`Szczegóły dla etapu: ${stage.name}`);
        }}
        onSelectOrder={(stage) => {
          setSelectedZamowienieId(stage.zamowienie_id);
          setSelectedShipmentDate(stage.data_spedycji);
        }}
        handleCenterOnStage={handleCenterOnStage}
      />
      <ModalGrupyTechnologii modalGrupyOpen={modalGrupyOpen} setModalGrupyOpen={setModalGrupyOpen} contextMenu={contextMenu} selectedGrup={selectedGrup} />
    </div>
  );
};

export default GanttChartAll;